document.addEventListener("DOMContentLoaded", function(event) { 
    init();
});

function init(){

    if(typeof window._callback != 'undefined'){
        
        let callback = window._callback;
        let callback_params = (typeof window._callback_params != 'undefined') ? window._callback_params : [];

        run_callback(callback, callback_params);
        
    }

}

export function run_callback(callback, callback_params){
    
    if(
        typeof callback == 'string' 
        && callback != '' 
        && typeof eval('window.app.' + callback) == 'function'
    ){

        let _callback = eval('window.app.' + callback );
        _callback(callback_params);

    }

        // if(
            
        // ){

        //     eval('window.app.' + route + '.init();');
        //     return;
        // } 

        // let callbacks = window.app;
        // let _callback = callback.split('.');

        // while(_callback.length > 1){
            
        //     let part = _callback.shift();
        //     if(typeof callbacks[part] != 'undefined'){

        //         callbacks = callbacks[part];

        //     } else {

        //         _callback = [null];
        //         break;

        //     }

        // }

        // if(
        //     _callback.length == 1 
        //     && _callback != null
        //     && typeof callbacks[_callback] == 'function'
        // ){
        //     callbacks[_callback](callback_params);
        // }

}